export default "__VITE_ASSET__BHBEL3Z___"